"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const initialData_1 = __importDefault(require("./initialData"));
const formToPayloadDataHandler_1 = require("./formToPayloadDataHandler");
const schema_1 = __importDefault(require("./schema"));
const payloadToFormDataHandler_1 = require("./payloadToFormDataHandler");
const uiSchema_1 = __importDefault(require("./uiSchema"));
const onHandleChange_1 = require("./onHandleChange");
const teleMedicineTemplate = {
    formToPayloadDataHandler: formToPayloadDataHandler_1.teleMedicineFormToPayloadDataHandler,
    payloadToFormDataHandler: payloadToFormDataHandler_1.teleMedicinePayloadToFormDataHandler,
    initialData: initialData_1.default,
    schema: schema_1.default,
    onHandleChange: onHandleChange_1.onHandleChange,
    onHandleChangeDependencies: onHandleChange_1.onHandleChangeDependencies,
    uiSchema: uiSchema_1.default,
};
exports.default = teleMedicineTemplate;
